<template>
  <div
    class="fixed left-20 bottom-20"
    :class="!isOpen ? 'auto' : 'chat-box'"
    :style="{ zIndex: 200 }"
  >
    <div v-show="!isOpen">
      <img
        v-tooltip="'AI Assistance'"
        src="~/assets/images/logo.png"
        class="max-w-[60px] cursor-pointer"
        alt="AI Assistance"
        data-id="personalpeiman-reddot-onetime"
        @click="toggleChat"
      />
    </div>
    <div v-show="isOpen" class="w-full h-full relative shadow-xl">
      <XMarkIcon
        v-tooltip="'Close'"
        class="w-6 absolute cursor-pointer right-5 top-4"
        @click="toggleChat"
      />
      <iframe
        ref="piemanIframe"
        :src="$config.public.piemanBaseUrl"
        class="w-full h-full rounded-xl"
        @load="sendMessageToIframe"
      ></iframe>
    </div>
  </div>
</template>

<script>
import { ChatBubbleLeftRightIcon, XMarkIcon } from '@heroicons/vue/24/outline'
export default {
  name: 'PiemanContainer',
  components: {
    ChatBubbleLeftRightIcon,
    XMarkIcon,
  },
  data() {
    return {
      isOpen: false,
    }
  },
  methods: {
    toggleChat() {
      this.isOpen = !this.isOpen
    },
    sendMessageToIframe() {
      const iframe = this.$refs.piemanIframe
      const token = this.$auth.getCookie()
      const tenantName = this.$auth.getTenantName()
      iframe.contentWindow.postMessage(
        {
          access_token: token ? token.split(' ')[1] : null,
          tenant_name: tenantName ?? null,
        },
        '*'
      )
    },
  },
}
</script>
